import { state } from './state'
import _ from 'lodash'
import utils from '../utils'

export const getters = {
    getIsLogin: state => state.token !== null,

    Serieses: state => {
      console.log('++++++ state.seriesesInState :', state.seriesesInState)
      if (state['seriesesInState']) {
        return utils.getObserveValue(state.seriesesInState)
      }
      return []
    },

    getCurrentCourseInState: state => state.currentCourse,

    getSeriesesJsonRequestStatus: state => state.requestSeriesesJson,

    getSeriesesFileCount: state => state.seriesesFiles.length,

    seriesesFiles: state => state.seriesesFiles,

    seriesesFilesLoading: state => state.seriesesFilesLoading,
}



// WEBPACK FOOTER //
// ./src/vuex/getters.js